import { COMPANY_NAME } from '../constants';

function Header() {
  const navItems = [
    { label: 'Source', href: '#profile' },
    { label: 'Address', href: '#location' },
    { label: 'Details', href: '#details' },
  ];

  return (
    <header className="sticky top-0 z-40 border-b border-fd-line bg-fd-ivory/92 backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-4">
        <a href="#top" className="flex items-center gap-3 font-black tracking-wide text-fd-ink">
          <span className="flex h-11 w-11 items-center justify-center border-2 border-fd-ink bg-fd-paper font-serif text-sm text-fd-ink shadow-seal">
            FD
          </span>
          <span>{COMPANY_NAME}</span>
        </a>
        <nav aria-label="Primary" className="hidden items-center gap-7 text-sm font-semibold text-fd-stone md:flex">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className="px-1 transition hover:text-fd-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fd-blue focus-visible:ring-offset-4 focus-visible:ring-offset-fd-ivory">
              {item.label}
            </a>
          ))}
        </nav>
        <a
          href="#details"
          className="border-2 border-fd-ink bg-fd-ink px-5 py-2.5 text-sm font-bold text-fd-ivory transition hover:bg-fd-paper hover:text-fd-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fd-blue focus-visible:ring-offset-2 focus-visible:ring-offset-fd-ivory"
        >
          View details
        </a>
      </div>
    </header>
  );
}

export default Header;
